import { createContext, useContext } from "react";

import { IndeterminateFlagValue } from "@safetyculture/s12-apis-connect-web/s12/featureflags/v1/featureflag_pb";

export type FeatureFlag = {
  [key: string]: IndeterminateFlagValue;
};

export type FeatureFlagsContextType = {
  featureFlags: FeatureFlag;
  setFeatureFlags: React.Dispatch<React.SetStateAction<FeatureFlag>>;
  isFeatureFlagsLoading: boolean;
  setIsFeatureFlagsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>(
  {} as FeatureFlagsContextType
);

export const UseGetFeatureFlagValue = (flagName: string) => {
  const { featureFlags } = useContext(FeatureFlagsContext);
  // Return early if feature flag does not exist.
  if (!featureFlags || !featureFlags.hasOwnProperty(flagName)) {
    return undefined;
  }
  return featureFlags[flagName].value.value;
};
